<ng-template #editLogsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="editLogsTitle">
      <i class="fa fa-history"></i> Histórico de edições
      <span class="sub" *ngIf="userLabel">{{ userLabel }}</span>
    </h4>
    <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="loading" class="text-center py-3 edit-log-empty" data-testid="edit-logs-loading">
      <i class="fa fa-spinner fa-spin me-1"></i> Carregando histórico...
    </div>

    <div *ngIf="!loading && error" class="alert alert-danger" data-testid="edit-logs-error">
      <i class="fa fa-exclamation-triangle me-1"></i>
      {{ error }}
    </div>

    <div
      *ngIf="!loading && !error && result?.data?.length === 0"
      class="sf-card empty"
      data-testid="edit-logs-empty"
    >
      <i class="fa fa-history"></i>
      <p>Nenhuma edição registrada para esta conta.</p>
    </div>

    <div *ngIf="!loading && !error && result?.data?.length > 0">
      <div
        *ngFor="let log of result.data; trackBy: trackByLogId"
        class="sf-card edit-log mb-3"
        data-testid="edit-log-item"
      >
        <div class="edit-log-header">
          <span class="edit-log-date meta-chip">
            <i class="fa fa-clock-o"></i>
            {{ log.created_at | date : "dd/MM/yyyy, HH:mm:ss" }}
          </span>
          <span class="edit-log-editor meta-chip">
            <i class="fa fa-user"></i>
            <ng-container *ngIf="log.editor_id; else systemEditor">
              {{ log.editor_name }}
              <small class="edit-log-subtitle" *ngIf="log.editor_email">({{ log.editor_email }})</small>
            </ng-container>
            <ng-template #systemEditor><i>Sistema</i></ng-template>
          </span>
          <span class="edit-log-ip edit-log-subtitle meta-chip" *ngIf="log.ip">
            <i class="fa fa-globe"></i>{{ log.ip }}
          </span>
        </div>

        <div class="table-responsive">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>Campo</th>
                <th>De</th>
                <th>Para</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let change of log.changed_fields">
                <td>{{ change.field | userFieldLabel }}</td>
                <ng-container *ngIf="isMasked(change); else eventOrValues">
                  <td colspan="2" class="edit-log-subtitle" data-testid="edit-log-masked">
                    <i class="fa fa-lock me-1"></i> Valor não registrado por segurança
                  </td>
                </ng-container>
                <ng-template #eventOrValues>
                  <ng-container *ngIf="isEventField(change.field); else plainValues">
                    <td colspan="2" data-testid="edit-log-event">{{ eventDetail(change) }}</td>
                  </ng-container>
                </ng-template>
                <ng-template #plainValues>
                  <td class="edit-log-old">{{ formatValue(change.old) }}</td>
                  <td class="edit-log-new">{{ formatValue(change.new) }}</td>
                </ng-template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <app-pagination
        *ngIf="result.total > result.per_page"
        look="v2"
        [currentPage]="result.current_page"
        [itemsPerPage]="result.per_page"
        [totalItems]="result.total"
        (pageChanged)="load($event)"
      ></app-pagination>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--secondary" (click)="modal.dismiss()">Fechar</button>
  </div>
</ng-template>
